import BaseModel from './BaseModel';

class PolicyholderDetailMetricsModel extends BaseModel {
  init(data) {
    this.id = data.id || 0;
    this.name = data.name || '';
    this.loginsTotal = data.logins_total || 0;
    this.workRequestsThisMonth = data.work_requests_this_month || 0;
    this.workOrdersCompletedThisMonth = data.work_orders_completed_this_month || 0;
    this.workOrdersOverdueTotal = data.work_orders_overdue_total || 0;
  }
}

export default PolicyholderDetailMetricsModel;
